import React from 'react';
import ApiFetch from "../components/ApiFetch";

export async function getStyleList(){
    return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/style").then((r)=>{
        return r.json().then((json)=>{
            return json
        })
    })
}
export async function setStyle(styleName,prompt,negativePrompt){
    return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/style",
    {styleName:styleName,prompt:prompt,negativePrompt:negativePrompt}).then((r)=>{
        return r.json().then((json)=>{
            return json
        })
    })
}
export async function deleteStyleList(idList){
    return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/style",
    {idList:idList}).then((r)=>{
        return r.json().then((json)=>{
            return json
        })
    })
}